<template>
  <div>
    <app-heading :text="'NBN Order Correction'" :heading="'main'"></app-heading>

    <v-divider class="mt-6 mb-4"></v-divider>

    <v-alert dense class="mb-4" color="orange" icon="mdi-alert">
      Only correct an order here when a request for manual modification has
      been raised and the order has already been modified in the NBN Co portal.
    </v-alert>

    <v-row class="mb-4" align="end">
      <v-col cols="12" md="8" lg="6">
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Search by NBN Order ID, AVC ID, customer, or wholesaler"
          outlined
          dense
          hide-details
          clearable
          @keyup.enter="searchOrders"
          @click:append="searchOrders"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" lg="2">
        <v-btn class="primary" :disabled="!keyword" @click="searchOrders">
          Search
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="searchError" type="error" dense text class="mb-4">
      {{ searchError }}
    </v-alert>

    <v-data-table
      :headers="resultHeaders"
      :items="searchResults"
      :loading="isSearching"
      item-key="id"
      class="mb-6"
      dense
      :items-per-page="10"
      @click:row="selectOrder"
    >
      <template v-slot:item.status="{ item }">
        {{ item.status || "—" }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small class="primary" @click.stop="selectOrder(item)">Select</v-btn>
      </template>
      <template v-slot:no-data>
        {{ hasSearched ? "No matching NBN orders found." : "Search for an NBN order to begin." }}
      </template>
    </v-data-table>

    <div v-if="selectedOrder">
      <nbn-order-correction-form
        :order="selectedOrder"
        :embedded="true"
        @corrected="onCorrected"
      ></nbn-order-correction-form>
    </div>
  </div>
</template>

<script>
import NbnOrderCorrectionForm from "@/components/orderQualification/nbn-order-correction-form";

export default {
  name: "NbnOrderCorrection",
  components: { NbnOrderCorrectionForm },
  data: () => ({
    keyword: "",
    isSearching: false,
    hasSearched: false,
    searchError: "",
    searchResults: [],
    selectedOrder: null,
    resultHeaders: [
      { text: "NBN Order ID", value: "nbnOrderId" },
      { text: "AVC ID", value: "avcId" },
      { text: "Status", value: "status" },
      { text: "Customer", value: "customerName" },
      { text: "Wholesaler", value: "wholesaler" },
      { text: "", value: "actions", sortable: false, width: 110 }
    ]
  }),
  created() {
    const queryId = this.$route.query.nbnOrderId || this.$route.query.keyword;
    if (queryId) {
      this.keyword = String(queryId);
      this.searchOrders();
    }
  },
  methods: {
    mapSearchResult(item) {
      return Object.assign({}, item, {
        customerName: [item.customerFirstname, item.customerSurname]
          .filter(Boolean)
          .join(" ")
      });
    },
    searchOrders() {
      const vm = this;
      if (!vm.keyword) {
        return;
      }

      vm.isSearching = true;
      vm.searchError = "";
      vm.hasSearched = true;
      vm.selectedOrder = null;

      vm.getNbnConnectOrders({
        keyword: vm.keyword,
        statusFilter: [],
        pageSize: 25,
        pageNumber: 1
      })
        .then(data => {
          const items = data.items || (data.data && data.data.items) || [];
          vm.searchResults = items.map(vm.mapSearchResult);
          if (vm.searchResults.length === 1) {
            vm.selectOrder(vm.searchResults[0]);
          }
        })
        .catch(error => {
          vm.searchResults = [];
          vm.searchError =
            (error && error.message) || "Unable to search NBN orders.";
        })
        .finally(() => {
          vm.isSearching = false;
        });
    },
    selectOrder(item) {
      this.selectedOrder = item;
    },
    onCorrected(updatedOrder) {
      this.selectedOrder = Object.assign({}, this.selectedOrder, updatedOrder);
      this.searchResults = this.searchResults.map(item =>
        item.id === this.selectedOrder.id
          ? Object.assign({}, item, updatedOrder)
          : item
      );
    }
  }
};
</script>
